import React from 'react';
import ReportViewer from "./base/ReportViewer";

const RapportDeCaisse = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"RapportDeCaisseReport"} />
        </div>
    );
}
export default RapportDeCaisse; 
